import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedPortalRoute from "@/components/ProtectedPortalRoute";
import Dashboard from "./pages/Dashboard";
import NotFound from "./pages/NotFound";
import Login from "./pages/Login";
import Callback from "./pages/Callback";
import Attendance from "@/pages/Attendance.tsx";
import Tasks from "@/pages/Tasks.tsx";
import Support from "@/pages/Support.tsx";
import MyDocuments from "@/pages/MyDocuments.tsx";
import Me from "@/pages/Me.tsx";
import Requests from "./pages/Requests";
import Services from "./pages/Services";
import LeaveRequest from "./pages/LeaveRequest";
import ServiceCertificateRequest from "./pages/services/salary-certificate/salary-certificate";
import ServiceCertificateRequestPrint from "./pages/services/salary-certificate/salary-certificate-print";
import ServiceRemoteWork from "./pages/services/remote-work/remote-work";
import ServiceLaeavePermission from "./pages/services/leave-permission/leave-permission";
import MePrint from "./pages/Me-export";
import ServiceLeaveRequest from "./pages/services/leave-request/leave-request";
import ServiceTechnicalSupport from "./pages/services/technical-support/technical-support";
import ServiceFieldVisit from "./pages/services/field-visit/field-visit";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <LanguageProvider>
      <AuthProvider>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/callback" element={<Callback />} />
              <Route path="/support" element={<Support />} />
              <Route
                path="/"
                element={
                  <ProtectedPortalRoute>
                    <Dashboard />
                  </ProtectedPortalRoute>
                }
              />
              <Route
                path="/me"
                element={
                  <ProtectedPortalRoute>
                    <Me />
                  </ProtectedPortalRoute>
                }
              />
              <Route
                path="/attendance"
                element={
                  <ProtectedPortalRoute>
                    <Attendance />
                  </ProtectedPortalRoute>
                }
              />
              <Route
                path="/tasks"
                element={
                  <ProtectedPortalRoute>
                    <Tasks />
                  </ProtectedPortalRoute>
                }
              />
              <Route
                path="/documents"
                element={
                  <ProtectedPortalRoute>
                    <MyDocuments />
                  </ProtectedPortalRoute>
                }
              />
              <Route
                path="/services"
                element={
                  <ProtectedPortalRoute>
                    <Services />
                  </ProtectedPortalRoute>
                }
              />
              {/* <Route
                path="/services/leave-request"
                element={
                  <ProtectedPortalRoute>
                    <LeaveRequest />
                  </ProtectedPortalRoute>
                }
              /> */}
              <Route
                path="/services/salary-certificate"
                element={
                  <ProtectedPortalRoute>
                    <ServiceCertificateRequest />
                  </ProtectedPortalRoute>
                }
              />
              <Route
                path="/services/salary-certificate-print"
                element={
                  <ProtectedPortalRoute>
                    <ServiceCertificateRequestPrint />
                  </ProtectedPortalRoute>
                }
              />
              <Route
                path="/services/remote-work"
                element={
                  <ProtectedPortalRoute>
                    <ServiceRemoteWork />
                  </ProtectedPortalRoute>
                }
              />
              <Route
                path="/services/leave-permission"
                element={
                  <ProtectedPortalRoute>
                    <ServiceLaeavePermission />
                  </ProtectedPortalRoute>
                }
              />
              <Route
                path="/services/leave-request"
                element={
                  <ProtectedPortalRoute>
                    <ServiceLeaveRequest />
                  </ProtectedPortalRoute>
                }
              />
              <Route
                path="/services/technical-support"
                element={
                  <ProtectedPortalRoute>
                    <ServiceTechnicalSupport />
                  </ProtectedPortalRoute>
                }
              />
              <Route
                path="/services/field-visit"
                element={
                  <ProtectedPortalRoute>
                    <ServiceFieldVisit />
                  </ProtectedPortalRoute>
                }
              />
              <Route
                path="/requests"
                element={
                  <ProtectedPortalRoute>
                    <Requests />
                  </ProtectedPortalRoute>
                }
              />
              
              <Route
                path="/me/print"
                element={
                  <ProtectedPortalRoute>
                    <MePrint />
                  </ProtectedPortalRoute>
                }
              />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </TooltipProvider>
      </AuthProvider>
    </LanguageProvider>
  </QueryClientProvider>
);

export default App;
